import axios, {AxiosResponse} from "axios";

const PATH = "/documents";

export type DocumentType = "PAYROLL" | "INCOME_TAX";

export interface Document {
  id: string,
  filename: string,
  documentType: DocumentType,
  correctionNumber: number,
  documentDate: string,
  contentType?: string,
  sizeBytes?: number,
  createdAt: string
}

export interface YearCount {
  year: number,
  count: number
}

export interface DocumentsMeta {
  selectedYear?: number,
  years: Array<YearCount>,
  total?: number
}

export interface DocumentsResponse {
  data: Array<Document>,
  meta: DocumentsMeta
}

class DocumentService {

  getDocuments(year?: number): Promise<AxiosResponse<DocumentsResponse>> {
    return axios.get(PATH, {
      params: {
        year: year
      }
    });
  }

  download(id: string): Promise<AxiosResponse<Blob>> {
    return axios.get(`${PATH}/${id}/content`, {
      responseType: "blob"
    });
  }
}

export default new DocumentService();
